import { Dtos, SuretyAccountId } from "@inrev/common";
import { useAuthenticatedUser } from "@portal/providers/AuthenticatedUserProvider";
import { useQuery } from "@tanstack/react-query";
import { ApiError } from "../../utils/error";
import { useRequest } from "../../utils/request";
import { accountBondingLineQueryKey } from "./account.keys";

export const useFetchSuretyAccountBondingLines = (accountId: SuretyAccountId) => {
	const { get } = useRequest();
	const { user } = useAuthenticatedUser();

	const isAdmin = user.type === "admin";

	const { data, error, isLoading, refetch } = useQuery({
		queryKey: accountBondingLineQueryKey(accountId),
		queryFn: async () => {
			try {
				const url = isAdmin
					? `/v2/admin/surety/accounts/${accountId}/bonding-lines`
					: `/v2/surety/accounts/${accountId}/bonding-lines`;
				return await get<Dtos.SuretyAccount.BondingLine.Get.Response>(url);
			} catch (error) {
				if (error instanceof ApiError && error.statusCode === 404) {
					return null;
				}
				throw error;
			}
		},
	});

	return {
		bondingLines: data,
		bondingLinesError: error,
		bondingLinesIsLoading: isLoading,
		refetchBondingLines: refetch,
	};
};
